import React, { useEffect, useState, useRef } from 'react';
import { CheckCheck, CircleX, Construction, MapPin, Repeat1, SendHorizonal, SendHorizonalIcon, Trash2 } from 'lucide-react';
import icEmpire from "../assets/logos/logo-empire-str.png";
import { useSocket } from '../Context/SocketContext';
import moment from 'moment';
import { infoUser } from '../utils/auth';
import Loader from './Loader';
import { post } from '../utils/fetcher';
import TalkTypeValidPaiement from './TalkTypeValidPaiement';
import TalkTypeRefusePaiement from './TalkTypeRefusePaiement';
import TalkTypeWaitAskPaiement from './TalkTypeWaitAskPaiement';
import TalkTypeWaitAskPaiementAccept from './TalkTypeWaitAskPaiementAccept';
import TalkTypeWaitAskPaiementReceived from './TalkTypeWaitAskPaiementReceived';
import TalkTypeWaitAskPaiementRefuseReceived from './TalkTypeWaitAskPaiementRefuseReceived';
import TalkTypeWaitAskPaiementRefuse from './TalkTypeWaitAskPaiementRefuse';

const CenterTalkSearch = ({ result, selectConversation }) => {
    const { projectJson } = useSocket()

    return (
        <div className='container-center-talk-search'>
            {result?.length > 0 && result.map((el, el_i) => (
                <button onClick={() => selectConversation(el)} key={"search_" + el_i} className='py1 df gap1'>
                    <img className='avatar' src={projectJson?.href + "/images/users/" + el.path}></img>
                    <div className='df fdc'>
                        <p className='cw fr'>{el.email}</p>
                        <div className='df gap1'>
                            <p className='cw fr'>{el.firstname}</p>
                            <p className='cw fr'>{el.lastname}</p>
                        </div>
                        <p className='cw fi'>{el.ip_adress}</p>
                    </div>
                </button>
            ))}
        </div>
    );
};

export default CenterTalkSearch;